import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import { getSketchOrders } from "../../actions/sketchOrdersActions";
import SketchOrderTable from "../../components/SketchOrderTable/SketchOrderTable";
import SketchOrderList from "../../components/SketchOrderList/SketchOrderList";
import queryString from "query-string";
import {SketchOrderSortParameter} from "../../lib/sketchOrderSortParameters";
import {OrderParameter} from "../../lib/OrderParameters";
import OrdersTabs from "../OrdersTabs";

export class MyAssignedSketchOrders extends Component {
    state = {
        sort: SketchOrderSortParameter.DueDate,
        order: OrderParameter.Ascending
    };

    getSketchOrders = async (page = 1) => {
        const queryParams = queryString.parse(this.props.location.search);

        const {
            statusIds,
            organizationId
        } = queryParams;
        let statusesToFilterBy;
        if (statusIds && !Array.isArray(statusIds)) {
            statusesToFilterBy = [];
            statusesToFilterBy.push(statusIds);
        } else {
            statusesToFilterBy = statusIds;
        }
        await this.props.dispatch(getSketchOrders(page, statusesToFilterBy, [this.props.currentUser.userId], organizationId, this.state.order, this.state.sort));
    };

    async componentDidMount() {
        await this.getSketchOrders();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            await this.getSketchOrders();
        }
    };

    getNextPage = async () => {
        const nextPage = this.props.currentPage + 1;
        await this.getSketchOrders(nextPage);
    };

    getPrevPage = async () => {
        const prevPage = this.props.currentPage - 1;
        await this.getSketchOrders(prevPage);
    };

    handleOnSortClick = (sort, order) => {
        this.setState({
            sort,
            order
        }, async () => {
            await this.getSketchOrders();
        });
    };

    render() {
        const isSketchOsAdmin = () => this.props.currentUserRoles.isAdmin || this.props.currentUserRoles.isSketchOsAdmin;

        const queryParams = queryString.parse(this.props.location.search);
        const {
            statusIds,
            organizationId,
        } = queryParams;

        const numberOfStatusFilters = () => {
            if (!statusIds) {
                return 0;
            }

            if (!Array.isArray(statusIds)) {
                return 1;
            }

            return statusIds.length;
        };
        const numberOfOrganizationFilters = (organizationId) ? 1 : 0;

        return (
            <div>
                <Hidden smDown>
                    <SketchOrderTable
                        sketchOrders={this.props.sketchOrders}
                        sketchOrderIds={this.props.sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onNextPageClick={this.getNextPage}
                        onPrevPageClick={this.getPrevPage}
                        showProjectName={isSketchOsAdmin()}
                        showOrganizationName={isSketchOsAdmin()}
                        numberOfStatusFilters={numberOfStatusFilters()}
                        numberOfOrganizationFilters={numberOfOrganizationFilters}
                        canFilter
                        showStatus
                        showDueDate
                        canFilterByOrganization={isSketchOsAdmin()}
                        showRequester={isSketchOsAdmin()}
                        showLinksToSupportDashboard={this.props.currentUserRoles.isAdmin}
                        showTimeSinceRequested
                        isFetching={this.props.isFetching}
                        canSortByRequestedDate
                        canSortByUpdatedDate
                        canSortByDueDate
                        showLastUpdatedAtTime
                        sort={this.state.sort}
                        order={this.state.order}
                        onSortClick={this.handleOnSortClick}
                        currentUserName={this.props.currentUser.userName}
                    />
                </Hidden>
                <Hidden mdUp>
                    <SketchOrderList
                        sketchOrders={this.props.sketchOrders}
                        sketchOrderIds={this.props.sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onNextPageClick={this.getNextPage}
                        onPrevPageClick={this.getPrevPage}
                        showOrganizationName={isSketchOsAdmin()}
                        numberOfStatusFilters={numberOfStatusFilters()}
                        numberOfOrganizationFilters={numberOfOrganizationFilters}
                        canFilter
                        showStatus
                        showLastUpdatedAtTime
                        canFilterByOrganization={isSketchOsAdmin()}
                        showOwner={isSketchOsAdmin()}
                        showRequester={isSketchOsAdmin()}
                        isFetching={this.props.isFetching}
                    />
                </Hidden>
            </div>
        );
    }
}

MyAssignedSketchOrders.propTypes = {
    dispatch: PropTypes.func.isRequired,
    sketchOrders: PropTypes.shape({
        sketchOrder: PropTypes.shape({ 
            id: PropTypes.number.isRequired,
            projectName: PropTypes.string,
            requestedDate: PropTypes.string.isRequired,
            address: PropTypes.string,
            city: PropTypes.string,
            region: PropTypes.string,
            postCode: PropTypes.string,
            country: PropTypes.string,
        })
    }).isRequired,
    totalResults: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    currentUserRoles: PropTypes.shape({
        isAdmin: PropTypes.bool.isRequired,
        isSketchOsAdmin: PropTypes.bool.isRequired,
        isSketchTech: PropTypes.bool.isRequired,
    }).isRequired,
    currentUser: PropTypes.shape({
        userId: PropTypes.number.isRequired,
        userName: PropTypes.string.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
    isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    const {
        sketchOrders: sketchOrdersStore,
        currentUserRoles,
        currentUser
    } = state;
    const {
        sketchOrders,
        totalResults,
        currentPage,
        totalPages,
        isFetching,
        ids: sketchOrderIds,
    } = sketchOrdersStore;

    return {
        sketchOrders,
        totalResults,
        currentPage,
        totalPages,
        currentUserRoles,
        currentUser,
        isFetching,
        sketchOrderIds,
    }
};

export default connect(mapStateToProps)(MyAssignedSketchOrders);
